export const STORE = 'store'
export const EVENT = 'event'
export const EFFECT = 'effect'
export const DOMAIN = 'domain'
export const SCOPE = 'scope'
export const SAMPLER = 'sampler'
export const CROSSLINK = 'crosslink'
export const MAP = 'map'
export const STACK = 'stack'
export const VALUE = 'value'
export const REG_A = 'a'
